<template>
	<Row id="custom-row">
		<div class="xl:container gap-[80px]">
			<Layout>
				<header class="entry-header">
					<h1
						class="entry-title"
						v-html="pageTitle"
					/>
				</header>
				<div
					class="content"
					v-html="pageContent"
				/>
			</Layout>
		</div>
	</Row>
</template>
<script setup>
import Layout from "~/components/layout/Legal.vue";

const { pageTitle, pageContent } = await useLegalPage('code-of-conduct');
</script>
<style lang="scss">
@import "@assets/utils.scss";

#custom-row {
	display: block;

	@include breakpoint(lg) {
		display: flex;
	}
}

#custom-row #toc_container .toc_title {
	margin-bottom: 0;
}

#custom-row .content p {
	margin-bottom: 32px;
}

#custom-row .content .toc_list a {
	color: #fff;
}

#custom-row #toc_container ul li {
	font-weight: 600;
}

#custom-row ol li {
	padding-left: 8px;
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row ol li::marker {
	content: "■";
	color: #3b82f6;
}

#custom-row ol li ol li::marker {
	content: "■";
	color: #1e3a8a;
}

#custom-row td {
	padding: 8px 8px;
	border: 1px solid #000;
}

#custom-row p strong {
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row .content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}
#custom-row .content a {
	color: #3b82f6;
}

#custom-row .content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}
</style>
